export default "__VITE_ASSET__BfZtL$PL__"